module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap classify-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "click": _vm.searchgoods,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "flex-item tab-content"
  }, [_c('div', {
    ref: "tabBar",
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-item verticalM",
    class: {
      active: _vm.tabIndex == 'essence'
    },
    on: {
      "click": function($event) {
        _vm.tabIndex = 'essence';
        _vm.isTabIndex = false
      }
    }
  }, [_c('span', {
    staticClass: "verticalM-box"
  }, [_vm._v("为您推荐")])]), _vm._v(" "), _vm._l((_vm.brandCates), function(brandItem, index) {
    return _c('div', {
      staticClass: "tab-item verticalM",
      class: {
        active: _vm.tabIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.selTab(index)
        }
      }
    }, [_c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v(_vm._s(brandItem.cates.linkName))])])
  })], 2), _vm._v(" "), _c('div', {
    ref: "brandContent",
    staticClass: "brand-content"
  }, [(_vm.tabIndex != 'essence') ? _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('imgs', {
    attrs: {
      "imagePath": _vm.brandCates[_vm.tabIndex] && _vm.brandCates[_vm.tabIndex].cates.imagePath.imagePath
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabIndex == 'essence') ? _c('div', {
    staticClass: "recommend-content"
  }, [(_vm.adverstore) ? _c('div', {
    staticClass: "banner",
    on: {
      "click": function($event) {
        return _vm.linkFn(_vm.adverstore.linkType, _vm.adverstore.linkTarget)
      }
    }
  }, [_c('imgs', {
    attrs: {
      "width": 500,
      "imagePath": _vm.adverstore && _vm.adverstore.imagePath && _vm.adverstore.imagePath.imagePath
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("精品推荐")])]), _vm._v(" "), _vm._l((_vm.boutiques), function(item, index) {
    return _c('div', {
      staticClass: "product-item square",
      on: {
        "click": function($event) {
          return _vm.scanDetail(item.storeId, item.goodsId, item.skuId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "width": 270,
        "height": 270,
        "imagePath": item.imagePath && item.imagePath.imagePath,
        "titleText": item.goodsName
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tabIndex != 'essence') ? _c('div', {
    staticClass: "product-content"
  }, [(_vm.adverbrand) ? _c('div', {
    staticClass: "banner",
    on: {
      "click": function($event) {
        return _vm.linkFn(_vm.adverbrand.linkType, _vm.adverbrand.linkTarget)
      }
    }
  }, [_c('imgs', {
    attrs: {
      "width": 500,
      "imagePath": _vm.adverbrand && _vm.adverbrand.imagePath && _vm.adverbrand.imagePath.imagePath
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(((_vm.brandCates[_vm.tabIndex] && _vm.brandCates[_vm.tabIndex].goodsList)), function(goodItem, goodIndex) {
    return _c('div', {
      staticClass: "product-item square",
      on: {
        "click": function($event) {
          return _vm.scanDetail(_vm.brandCates[_vm.tabIndex].cates.linkTarget, goodItem.goodsId, goodItem.skuId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "width": 270,
        "height": 270,
        "imagePath": goodItem && goodItem.imagePath && goodItem.imagePath.imagePath,
        "titleText": goodItem.goodsName
      }
    })], 1)
  })], 2) : _vm._e()])]), _vm._v(" "), _c('menus')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb2d3cb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classify/classify.vue
// module id = 421
// module chunks = 68